
// AUTH ENDPOINTS
export const endpoints = {
  SIGNUP_API:   "https://server-gksl.onrender.com/api/v2/auth/signup",
  LOGIN_API:   "https://server-gksl.onrender.com/api/v2/auth/login",
  PROFILE_API: "https://server-gksl.onrender.com/api/v2/userdetail/userDetail",
  SUBMISSION_API: "https://server-gksl.onrender.com/api/v2/submission",
  UPDATE_API: "https://server-gksl.onrender.com/api/v2/profile/updateProfile",
  LOGOUT_API: "https://server-gksl.onrender.com/api/v2/auth/logout",
  EMAIL_API: "https://server-gksl.onrender.com/api/v2/email/sendEmail",
  }

// export const endpoints = {
//   SIGNUP_API:   "http://localhost:4000/api/v2/auth/signup",
//   LOGIN_API:   "http://localhost:4000/api/v2/auth/login",
//   PROFILE_API: "http://localhost:4000/api/v2/userdetail/userDetail",
//   SUBMISSION_API: "http://localhost:4000/api/v2/submission",
//   UPDATE_API: "http://localhost:4000/api/v2/profile/updateProfile",
//   LOGOUT_API: "http://localhost:4000/api/v2/auth/logout",
//   EMAIL_API: "http://localhost:4000/api/v2/email/sendEmail"
// }


//   SIGNUP_API:   "/api/v2/auth/signup",
//   LOGIN_API:   "/api/v2/auth/login",
//   PROFILE_API: "/api/v2/userdetail/userDetail",
//   SUBMISSION_API: "/api/v2/submission",
//   UPDATE_API: "/api/v2/profile/updateProfile",
//   LOGOUT_API: "/api/v2/auth/logout",
// }
